export const TROMBINOS_PAGE = {
  title: "Élus & Conseil municipal",
  eyebrow: "Votre mairie",
  description:
    "Découvrez les membres du conseil municipal et les équipes qui accompagnent la vie communale au quotidien.",
  heroImageUrl:
    "https://www.olivier-ramonteu.fr/wp-content/uploads/blog/2025/2025-01-trombi-pourquoi/trombinoscope-entreprise-2.jpg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Mairie" },
    { label: "Élus & Conseil municipal" },
  ],
};

export const TROMBINO_TABS = [
  { value: "all", label: "Tous" },
  { value: "elected", label: "Conseil municipal" },
  { value: "personnel", label: "Services municipaux" },
];